
import apiSelfOrder from '../../../api/selfOrder';

const defaultState = () => ({
    discountSetting: {
        discount_value: 0,
        rebate_value: 0
    },
    productWarehouse: [],
    response: {
        code: '',
        message: ''
    },
    responseError: {},
    alert: '',
});

const state = defaultState();

const getters = {
    
};

const mutations = {
    setProductWarehouse(state, data) {
        state.productWarehouse = data
    },
    setDiscount(state, data) {
        state.discountSetting = data
    },
    saveResponse(state, data) {
        state.response = data
    },
    validationError(state, data) {
        state.responseError = data
    },
    failed(state, data) {
        state.alert = data
    },
};

const actions = {
    getProductWarehouse({ commit }, params){
        return new Promise((resolve, reject) => {
            apiSelfOrder.getProductWarehouse(params).then(({ data: { data } }) => {
                commit('setProductWarehouse', data.results )
                resolve(data.results)
            }).catch(err => {
                commit('setProductWarehouse', [] )
                reject(err)
            })
        })
    },
    getSelfOrderDiscount({ commit }, params){
        return new Promise((resolve, reject) => {
            apiSelfOrder.getSelfOrderDiscount(params).then(({ data: { data } }) => {
                commit('setDiscount', data.results )
                resolve(data.results)
            }).catch(err => {
                commit('setDiscount', [] )
                reject(err)
            })
        })
    },
    success({ commit }, data) {
        commit('setSnackbar', {
            show: true,
            color: 'green accent-4',
            text: data.message
        }, { root: true });
    },
    errorHandler({ commit }, response) {
        switch (response.message) {
            case 'error_validation':
            commit('validationError', response.data);
            break;

            default:
            commit('failed', { code: 'error_response', type: 'error', message: response.message });
            break;
        }
    },
    async saveProductSelfOrder({ commit, dispatch }, params) {
        await apiSelfOrder.saveProductSelfOrder(params).then( res => {
            const data = res.data;
            commit("saveResponse", data);
            commit('setSnackbar', {
                show: true,
                color: 'green accent-4',
                text: data.message
            }, { root: true });
        })
        .catch( err => {
            const data = err.response.data
            dispatch("errorHandler", data)

            //console.log(data.code)

            if (data.code == 400) {
                commit('setSnackbar', {
                    show: true,
                    color: 'red darken-2',
                    text: data.message
                }, { root: true });
            } else {
                commit('setSnackbar', {
                    show: true,
                    color: 'red darken-2',
                    text: 'Gagal menyimpan data'
                }, { root: true });
            }
        });
    },
    async saveDiscountSelfOrder({ commit, dispatch }, params) {
        await apiSelfOrder.saveDiscountSelfOrder(params).then( res => {
            const data = res.data;
            commit("saveResponse", data);
            commit('setSnackbar', {
                show: true,
                color: 'green accent-4',
                text: data.message
            }, { root: true });
        })
        .catch( err => {
            const data = err.response.data
            dispatch("errorHandler", data)

            //console.log(data.code)

            if (data.code == 400) {
                commit('setSnackbar', {
                    show: true,
                    color: 'red darken-2',
                    text: data.message
                }, { root: true });
            } else {
                commit('setSnackbar', {
                    show: true,
                    color: 'red darken-2',
                    text: 'Gagal menyimpan data'
                }, { root: true });
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};